<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 max-w25 mt-20 sidebarscroll"
  >
    <div class="flex  sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white ">
        BUG
      </h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="p-2  ">
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">Description</p>
        <textarea
          class="form-control"
          id="exampleFormControlTextarea3"
          rows="3"
        ></textarea>
      </div>
      <FileUploader class="mb-4" />
      <div class="mb-12">
        <base-input>
          <select class="form-control ">
            <option disabled="true">Select</option>
            <option>Open</option>
            <option>In-progress</option>
            <option>Reopen</option>
            <option>On-hold</option>
            <option>Closed</option>
          </select>
        </base-input>
      </div>
    </div>
    <footer class="footer-fix fixed bottom-0	w-1/4 ">
      <base-button block type="primary" class="rounded-none font-semibold"
        >SUBMIT</base-button
      >
    </footer>
  </side-bar>
</template>

<script>
import FileUploader from "@/components/FileUploader.vue";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    FileUploader
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  }
};
</script>
